<template>
  <div class="bill-delivery-container">
    <checkout-payment-headline :title="$t('checkout.infoAndPayment.shipment')"/>
    <div class="delivery-options-container">
      <div v-for="(option, index) in shipmentOptions"
           :key="index"
           class="delivery-option">
        <div class="item">
          <BaseRadio v-model="setDeliveryType"
                     variant="red"
                     :name="option.type"
                     :value="option.type"
                     :label="option.title"
                     :checked="option.type === setDeliveryType || option.checked"/>
        </div>
        <div v-if="$props.deliveryType === 'ship-store' && option.type === 'ship-store'" class="dropdown-group flex-1">
          <v-select class="select-dropdown location-info"
                    v-model="location"
                    :options="options"
                    :searchable="false"
                    label="address">
          </v-select>
        </div>
        <div v-if="$props.deliveryType === 'ship-differentAddress' && option.type === 'ship-differentAddress' ">
          <ShipmentForm v-model="$props.value" v-bind="$props"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import vSelect from 'vue-select'
import BaseRadio from '../../base/base-radio'
import ShipmentForm from './shipment-form'
import CheckoutPaymentHeadline from './checkout-payment-headline'
import { getStoreLocations } from '@/api/checkout'

export default {
  name: 'shipment-options',
  components: { BaseRadio, vSelect, ShipmentForm, CheckoutPaymentHeadline },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    deliveryType: String,
    cities: {
      type: Array,
      default: () => []
    },
    formSubmitted: Boolean
  },
  data () {
    return {
      options: [],
      location: {},
      shipmentOptions: [
        {
          title: this.$i18n.t('checkout.infoAndPayment.shipmentSameAddress'),
          type: 'ship-existingAddress',
          checked: true
        },
        {
          title: this.$i18n.t('checkout.infoAndPayment.shipmentDifferentAddress'),
          type: 'ship-differentAddress',
          checked: false
        },
        {
          title: this.$i18n.t('checkout.infoAndPayment.shipmentStore'),
          type: 'ship-store',
          checked: false
        }
      ]
    }
  },
  created () {
    this.getLocations()
  },
  computed: {
    setDeliveryType: {
      get () {
        return this.$props.deliveryType
      },
      set (val) {
        this.$emit('package-delivery-type', val)
      }
    }
  },
  methods: {
    getLocations () {
      getStoreLocations().then(res => {
        if (res.data.pointOfServices) {
          this.options = res.data.pointOfServices.map(pos => {
            return {
              address: `${pos.name} - ${pos.address.formattedAddress}`,
              id: pos.address.id
            }
          })
          this.location = this.options[0]
        }
      })
    }
  },
  watch: {
    location: {
      immediate: true,
      handler () {
        this.$emit('pos-id', this?.location?.id)
      }
    }
  }
}
</script>

<style scoped lang="scss">

.bill-delivery-container {
  margin-bottom: 3rem;

  @media (map_get($breakpoints, sm)) {
    margin-bottom: 4rem;
  }

  .delivery-options-container {
    margin-bottom: 10px;
    background-color: $white;
    padding: 30px 15px 10px;
    @media (map_get($breakpoints, sm)) {
      padding: 30px 40px 10px;
    }
  }

  .delivery-option {
    display: flex;
    flex-direction: column;
    line-height: 1.71;
    margin-bottom: 25px;

    &:hover {
      cursor: pointer;
    }

    /deep/ .checkbox-label {
      color: $dark;
      font-size: 14px;
      font-weight: 600;
    }
  }

  .item {
    display: flex;
  }

  .dropdown-group {
    margin-top: 25px;
    width: 100%;
    border: 1px solid $dark-grey;
    border-radius: 5px;
    @media (map_get($breakpoints, sm)) {
      margin-left: 33px;
      width: 93%;
    }
  }
}

</style>
